import useReCaptchaV3 from "../Shared/utils/useReCaptchaV3";

const useHandleFormCaptcha = (isRequired: boolean, isRegister = false) => {
  const { getV3Token, captchaVersion } = useReCaptchaV3({ isRegister });
  const handleFormCaptcha = async (captcha?: string) => {
    const isRecaptchaV3 = captchaVersion === "v3" && !isRequired;
    const version = isRecaptchaV3 ? "v3" : "v2";
    const captchaToken = isRecaptchaV3 ? await getV3Token() : captcha;
    return { captchaToken, captchaVersion: version };
  };
  return { handleFormCaptcha };
};

export default useHandleFormCaptcha;
